import React from 'react';
import RowHeaderHelp from '../../components/RowHeaderHelp';
import StepperImport from '../../components/organisms/steppers';
import { useLocation } from 'react-router-dom';

const Import: React.FC = () => {
  const location = useLocation<{
    mode?: 'edit' | 'create';
    startStep?: number;
    initialValues?: any;
    disableVehicleType?: boolean;
  }>();

  return (
    <div className="container-body no-padding">
      <RowHeaderHelp
        name={
          location.state?.mode === 'edit' ? 'Editar frete' : 'Nova Importação'
        }
      />
      <StepperImport
        key={
          (location.state?.initialValues as any)?.freightRequestId ||
          location.state?.startStep ||
          location.state?.mode ||
          'import'
        }
        mode={location.state?.mode}
        startStep={location.state?.startStep}
        initialValues={location.state?.initialValues}
        disableVehicleTypeFromState={location.state?.disableVehicleType}
      />
    </div>
  );
};

export default Import;

